import { AnimationTransitionRegistry } from "@visactor/vrender-animate/state/animation-states-registry";

export function registerStateTransition() {
    const animationTransitionRegistry = AnimationTransitionRegistry.getInstance();
    animationTransitionRegistry.registerTransition("update", "*", (() => ({
        allowTransition: !0,
        stopOriginalTransition: !1
    }))), animationTransitionRegistry.registerTransition("update", "disappear", (() => ({
        allowTransition: !0,
        stopOriginalTransition: !0
    }))), animationTransitionRegistry.registerTransition("update", "exit", (() => ({
        allowTransition: !0,
        stopOriginalTransition: !0
    }))), animationTransitionRegistry.registerTransition("state", "*", (() => ({
        allowTransition: !0,
        stopOriginalTransition: !1
    }))), animationTransitionRegistry.registerTransition("state", "disappear", (() => ({
        allowTransition: !0,
        stopOriginalTransition: !0
    }))), animationTransitionRegistry.registerTransition("state", "exit", (() => ({
        allowTransition: !0,
        stopOriginalTransition: !0
    })));
}
//# sourceMappingURL=state-transition.js.map